export default {
  production: false,
  app: {
    bundle: 'unowdtc',
    name: 'unowdtc',
    xClientID: 'unow-unowdtc',
    appBuild: 29,
    applicationId: '673195753',
    appName: 'unowdtc-comecast-ui-staging',
    majorVersion: '0',
    minorVersion: '0',
    patchVersion: '1',
    appVersionId: '673198239',
    asn: '52362',
    asnowner: 'Servicios Innovadores de Comunicacion y Entretenimiento, S.A.',
  },
  conviva: {
    ckey: '9fb5e56840541b72b48e07775bac04402ec811d4',
    gUrl: 'https://q9fb5e56840541b72b48e07775bac04402ec811d4.ts-testonly.conviva.com',
  },
  configUrl: 'https://config-service-cdn.unowcms-stag.quickplay.com',
};
